import { makeStyles } from '@material-ui/core'
import { Theme, themeContext } from '@smartb/archetypes-ui-components'
import React, { useContext } from 'react'
import { Edit } from '../../Icons'
import { TextButton } from '../TextButton'

const useStyles = (theme: Theme) =>
  makeStyles(() => ({
    icon: {
      width: '16px',
      height: '16px',
      marginRight: '5px'
    },
    root: {
      '& span': {
        color: theme.secondaryColor
      }
    }
  }))

interface EditButtonProps {
  onClick: (event: React.ChangeEvent<{}>) => void
  label?: string
  className?: string
  style?: React.CSSProperties
  disabled?: boolean
}

export const EditButton = (props: EditButtonProps) => {
  const { label, onClick, className, style, disabled = false } = props
  const theme = useContext(themeContext)
  const classes = useStyles(theme)()
  return (
    <TextButton
      onClick={onClick}
      className={`${className ?? ''} ${classes.root}`}
      style={style}
      disabled={disabled}
    >
      <Edit color={theme.secondaryColor} className={classes.icon} />
      {label}
    </TextButton>
  )
}
